import { UnstyledLink } from '@components/UnstyledLink';
import { UserAvatar } from '@components/UserAvatar/UserAvatar';
import { AvatarGroup, Chip, Paper, Stack, Typography } from '@mui/material';
import { getTenantIdentifier } from '@utils/getTenantIdentifier';
import { useIntl } from 'react-intl';
import { ProjectCardFragment } from './ProjectCard';

interface Props {
  project: ProjectCardFragment;
}

export const ProjectListItem: React.FC<Props> = ({ project }) => {
  const { formatMessage } = useIntl();
  const tenantIdentifier = getTenantIdentifier();
  const target = `/${tenantIdentifier}/projects/${project.id.toString()}/${project.isTemplate ? 'templateHome' : 'home'}`;

  return (
    <UnstyledLink to={target}>
      <Paper variant='outlined' sx={{ p: 2, width: '100%' }}>
        <Stack direction='row' spacing={2} alignItems='center' flexWrap='wrap'>
          <Stack flex={1} minWidth={0} spacing={0.5}>
            <Stack direction='row' spacing={1} alignItems='center' minWidth={0}>
              <Typography variant='h6' noWrap color={project.isArchived ? 'text.secondary' : 'text.primary'}>
                {project.name}
              </Typography>

              {project.isTemplate && (
                <Chip size='small' color='secondary' label={formatMessage({ id: 'Project template' })} />
              )}

              {project.isArchived && (
                <Chip size='small' label={formatMessage({ id: 'Archived' })} />
              )}
            </Stack>

           
            {project.description && (
              <Typography variant='body2' color='text.secondary' noWrap>
                {project.description}
              </Typography>
            )}
          </Stack>

          <AvatarGroup max={4}>
            {project.securityGroups.flatMap(group => group.members).map(user => (
              <UserAvatar key={user.id} displayName={user.fullName} />
            ))}
          </AvatarGroup>
        </Stack>
      </Paper>
    </UnstyledLink>
  );
};

